import { CLEANUP, Cleanup } from '../actions';
import {
  PROCESS_ENTRY, PROCESS_ENTRY_FAILURE, PROCESS_ENTRY_SUCCESS, ProcessEntry,
  ProcessEntryFailure,
  ProcessEntrySuccess,
} from '../actions/oneClickBet';
import {
  PROCESS_STAKES, PROCESS_STAKES_COMPLETE, ProcessStakes,
  ProcessStakesComplete,
} from '../actions/submission';
import { SubmissionState as Submission } from '../constants';
import { SubmissionState } from '../types/submission';

// ---

const initialState: SubmissionState = Submission.AWAITING;

export type SubmissionActions =
  | ProcessStakes
  | ProcessStakesComplete
  | ProcessEntry
  | ProcessEntrySuccess
  | ProcessEntryFailure
  | Cleanup;

export default function (
  state = initialState,
  action: SubmissionActions,
): SubmissionState {
  switch (action.type) {
    case PROCESS_STAKES:
    case PROCESS_ENTRY:
      return Submission.PROCESSING;

    case PROCESS_ENTRY_SUCCESS:
    case PROCESS_ENTRY_FAILURE:
    case PROCESS_STAKES_COMPLETE:
    case CLEANUP:
      return initialState;

    default:
      return state;
  }
}
